<template>
  <div class="page-wrapper">
    <header class="navbar">
      <div class="logo-wrap">
        <img class="logo" src="@/assets/img/substance-logo-2023.png" alt="Substance" />
      </div>
      <div class="right">
        <a href="#programmation" v-scroll-to:-95 class="link"><p class="caps-bold">HORAIRE<span> DE LA JOURNÉE</span></p></a>
        <a href="#" class="cta" @click.prevent="openform"><p class="caps-bold">PARTICIPER</p></a>
      </div>
    </header>

    <section class="hero">
      <img src="@/assets/img/hero-2026.svg" alt="Substance Lab 2025">
      <!-- <a href="#" class="cta outline float-cta">Rendez-vous annuel substance</a> -->
    </section>

    <section class="img-bloc stretch">
      <div class="data" data-inview="slideRight" data-delay="200">
        <h2 class="title big">Le LAB SUBSTANCE<br>Sommet de création, de contenu, de média et de RP</h2>
        <h3 class="title small">Concrétisez vos connaissances sur l'industrie</h3>
        <p class="text">
          Votre rendez-vous annuel pour tout savoir sur la création, le contenu, le média et les RP est de retour. Profitez de formations, panels, discussions et activité de réseautage pour rester à l'affût de toutes les meilleures pratiques et dernières tendances de l'industrie. Amenez votre savoir à un autre niveau pour garantir le succès de vos marques dans l'environnement actuel du marketing.
        </p>

        <div class="wrap-desc">
          <div class="col">
            <p class="text">
              EN BREF
            </p>
            <ul>
              <li class="text">+ de 15 experts</li>
              <li class="text">1&nbsp;&nbsp;journée complète de formations</li>
              <li class="text">Cocktail de réseautage</li>
              <li class="text">Rafraîchissements et lunchs fournis</li>
            </ul>
          </div>
          <div class="col">
            <p class="text">
              SUJETS COUVERTS
            </p>
            <ul>
              <li class="text">Marketing d'influence</li>
              <li class="text">Média</li>
              <li class="text">Relations publiques</li>
              <li class="text">Et plus encore</li>
            </ul>
          </div>
        </div>

        <!-- <a href="#" class="cta" @click.prevent="openform"><p class="caps-bold">Confirmer ma présence</p></a> -->
      </div>
      <div class="img" data-inview="slideLeft" data-delay="200">
        <div class="infos-card">
          <div class="info">
            <p class="title">QUAND</p>
            <p class="info-text">22 janvier <br> 9H30</p>
          </div>
          <div class="info">
            <p class="title">Où</p>
            <p class="info-text">messorem <small>2233 rue Pitt montréal</small></p>
          </div>
        </div>
      </div>
    </section>

    <section class="video-wrap" data-inview="fadeInUp" data-delay="200">
      <div class="youtube-embed">
        <iframe width="560" height="315" src="https://www.youtube.com/embed/VMxBnd1xkhg?si=MhvVhc67nEQjje-A" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
      </div>
    </section>

    <section id="programmation" class="programmation">
      <div class="title-wrap">
        <h2 class="title big" data-inview="fadeInUp" data-delay="200">Le Lab Substance 2026</h2>
      </div>

      <div class="row" data-inview="fadeInUp" data-delay="200">
        <div class="time">
          <p class="title">9h30</p>
        </div>
        <div class="bloc no-click bleu">
          <div class="top">
            <h3 class="title small">Arrivée, café, muffins et mot d'arrivée de Guillaume</h3>
            <p class="text salle">Le Labo</p>
          </div>
        </div>
      </div>

      <div class="row" data-inview="fadeInUp" data-delay="200">
        <div class="time">
          <p class="title">10h</p>
        </div>
        <div class="bloc-wrap">
          <div class="bloc" @click.prevent="openconference('event1')">
            <div class="top">
              <h3 class="title small">L’IA : entre fantasmes et faits</h3>
            </div>
            <div class="info">
              <p class="text salle">Le Labo</p>
              <div class="speaker">
                <img src="@/assets/img/river-lariviere.png" alt="River Larivière" />
                <img src="@/assets/img/marie-jade.webp" alt="Marie-Jade Filion" class="ml" />
                <img src="@/assets/img/genevieve-harel.png" alt="Geneviève Harel" class="ml" />
                <p class="text name"><span>/</span>  River Larivière <br> Marie-Jade Filion <br> Geneviève Harel</p>
              </div>
            </div>
            <div class="arrow">
              <svg width="26" height="16" viewBox="0 0 26 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M25.7071 8.70711C26.0976 8.31658 26.0976 7.68342 25.7071 7.29289L19.3431 0.928932C18.9526 0.538408 18.3195 0.538408 17.9289 0.928932C17.5384 1.31946 17.5384 1.95262 17.9289 2.34315L23.5858 8L17.9289 13.6569C17.5384 14.0474 17.5384 14.6805 17.9289 15.0711C18.3195 15.4616 18.9526 15.4616 19.3431 15.0711L25.7071 8.70711ZM0 9H25V7H0V9Z" fill="#2B2B2B"/>
              </svg>
            </div>
          </div>
          <p class="text or">ou</p>
          <div class="bloc" @click.prevent="openconference('event2')">
            <div class="top">
              <h3 class="title small">Micro, Nano, Macro influenceurs : quelle approche privilégier ?</h3>
            </div>
            <div class="info">
               <p class="text salle">L'Atelier</p>
              <div class="speaker">
                <img src="@/assets/img/marc-andre.webp" alt="Marc-André Dufresne" />
                <img src="@/assets/img/martin-alexis.png" alt="Martin Alexis Ramirez" class="ml" />
                <p class="text name"><span>/</span> Marc-André Dufresne <br> Martin Alexis Ramirez</p>
              </div>
            </div>
            <div class="arrow">
              <svg width="26" height="16" viewBox="0 0 26 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M25.7071 8.70711C26.0976 8.31658 26.0976 7.68342 25.7071 7.29289L19.3431 0.928932C18.9526 0.538408 18.3195 0.538408 17.9289 0.928932C17.5384 1.31946 17.5384 1.95262 17.9289 2.34315L23.5858 8L17.9289 13.6569C17.5384 14.0474 17.5384 14.6805 17.9289 15.0711C18.3195 15.4616 18.9526 15.4616 19.3431 15.0711L25.7071 8.70711ZM0 9H25V7H0V9Z" fill="#2B2B2B"/>
            </svg>

            </div>
          </div>
        </div>
      </div>

      <div class="row" data-inview="fadeInUp" data-delay="200">
        <div class="time">
          <p class="title">10h30</p>
        </div>
        <div class="bloc-wrap">
          <div class="bloc" @click.prevent="openconference('event3')">
            <div class="top">
              <h3 class="title small">L'influence repensée : de création à amplification</h3>
            </div>
            <div class="info">
              <p class="text salle">Le Labo</p>
              <div class="speaker">
                <img src="@/assets/img/marc-andre.webp" alt="Marc-André Dufresne" />
                <img src="@/assets/img/elise.webp" alt="Elise El-Nawar" class="ml" />
                <p class="text name"><span>/</span>  Marc-André Dufresne <br> Elise El-Nawar</p>
              </div>
            </div>
            <div class="arrow">
              <svg width="26" height="16" viewBox="0 0 26 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M25.7071 8.70711C26.0976 8.31658 26.0976 7.68342 25.7071 7.29289L19.3431 0.928932C18.9526 0.538408 18.3195 0.538408 17.9289 0.928932C17.5384 1.31946 17.5384 1.95262 17.9289 2.34315L23.5858 8L17.9289 13.6569C17.5384 14.0474 17.5384 14.6805 17.9289 15.0711C18.3195 15.4616 18.9526 15.4616 19.3431 15.0711L25.7071 8.70711ZM0 9H25V7H0V9Z" fill="#2B2B2B"/>
              </svg>
            </div>
          </div>
          <p class="text or">ou</p>
          <div class="bloc" @click.prevent="openconference('event4')">
            <div class="top">
              <h3 class="title small">De la visibilité à la considération: Brancher les RP au parcours client</h3>
            </div>
            <div class="info">
               <p class="text salle">L'Atelier</p>
              <div class="speaker">
                <img src="@/assets/img/sebastien-voyer.png" alt="Sébastien Voyer" />
                <img src="@/assets/img/juliette-ferland.png" alt="Juliette Ferland" class="ml" />
                <p class="text name"><span>/</span> Sébastien Voyer <br> Juliette Ferland</p>
              </div>
            </div>
            <div class="arrow">
              <svg width="26" height="16" viewBox="0 0 26 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M25.7071 8.70711C26.0976 8.31658 26.0976 7.68342 25.7071 7.29289L19.3431 0.928932C18.9526 0.538408 18.3195 0.538408 17.9289 0.928932C17.5384 1.31946 17.5384 1.95262 17.9289 2.34315L23.5858 8L17.9289 13.6569C17.5384 14.0474 17.5384 14.6805 17.9289 15.0711C18.3195 15.4616 18.9526 15.4616 19.3431 15.0711L25.7071 8.70711ZM0 9H25V7H0V9Z" fill="#2B2B2B"/>
            </svg>

            </div>
          </div>
        </div>
      </div>

      <div class="row" data-inview="fadeInUp" data-delay="200">
        <div class="time">
          <p class="title">11h</p>
        </div>
        <div class="bloc-wrap">
          <div class="bloc" @click.prevent="openconference('event5')">
            <div class="top">
              <h3 class="title small">Cas RONA : L'influence au service de la marque</h3>
             
            </div>
            <div class="info">
              <p class="text salle">Le Labo</p>
              <div class="speaker">
                <img src="@/assets/img/vanessa-beauregard.png" alt="Vanessa Beauregard" />
                <img src="@/assets/img/caroline-hurtubise.png" alt="Caroline Hurtubise" class="ml" />
                <p class="text name"><span>/</span> Vanessa Beauregard <br> Caroline Hurtubise</p>
              </div>
            </div>
            <div class="arrow">
              <svg width="26" height="16" viewBox="0 0 26 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M25.7071 8.70711C26.0976 8.31658 26.0976 7.68342 25.7071 7.29289L19.3431 0.928932C18.9526 0.538408 18.3195 0.538408 17.9289 0.928932C17.5384 1.31946 17.5384 1.95262 17.9289 2.34315L23.5858 8L17.9289 13.6569C17.5384 14.0474 17.5384 14.6805 17.9289 15.0711C18.3195 15.4616 18.9526 15.4616 19.3431 15.0711L25.7071 8.70711ZM0 9H25V7H0V9Z" fill="#2B2B2B"/>
            </svg>

            </div>
          </div>
          <p class="text or">ou</p>
          <div class="bloc" @click.prevent="openconference('event6')">
            <div class="top">
              <h3 class="title small">Nos apprentissages pour la recette du Ecom</h3>
              
            </div>
            <div class="info">
              <p class="text salle">L'Atelier</p>
              <div class="speaker">
                <img src="@/assets/img/philippe.png" alt="Philippe Petrin">
                <p class="text name"><span>/</span> Philippe Petrin</p>
              </div>
            </div>
            <div class="arrow">
              <svg width="26" height="16" viewBox="0 0 26 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M25.7071 8.70711C26.0976 8.31658 26.0976 7.68342 25.7071 7.29289L19.3431 0.928932C18.9526 0.538408 18.3195 0.538408 17.9289 0.928932C17.5384 1.31946 17.5384 1.95262 17.9289 2.34315L23.5858 8L17.9289 13.6569C17.5384 14.0474 17.5384 14.6805 17.9289 15.0711C18.3195 15.4616 18.9526 15.4616 19.3431 15.0711L25.7071 8.70711ZM0 9H25V7H0V9Z" fill="#2B2B2B"/>
            </svg>

            </div>
          </div>
        </div>
      </div>

      <div class="row" data-inview="fadeInUp" data-delay="200">
        <div class="time">
          <p class="title">11h30</p>
        </div>
        <div class="bloc" @click.prevent="openconference('event7')">
          <div class="top">
            <h3 class="title small">GAFAM vs. médias d'ici : Se démarquer pour atteindre les objectifs</h3>
            <p class="text salle">Le Labo</p>
          </div>
          <div class="info">
            <div class="speaker">
              <img src="@/assets/img/guillaume-brunet.png" alt="Guillaume Brunet" />
              <img src="@/assets/img/lapresse.png" alt="La Presse" class="ml" />
              <img src="@/assets/img/globe-mail.png" alt="Globe and Mail" class="ml" />
              <img src="@/assets/img/cegeco.png" alt="Média Tonik" class="ml" />
              <img src="@/assets/img/pelmorex.png" alt="Pelmorex" class="ml" />
              <p class="text name"><span>/</span> Guillaume Brunet <br> La Presse <br> Globe and Mail <br> Cogeco <br> Pelmorex</p>
            </div>
          </div>
          <div class="arrow">
            <svg width="26" height="16" viewBox="0 0 26 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M25.7071 8.70711C26.0976 8.31658 26.0976 7.68342 25.7071 7.29289L19.3431 0.928932C18.9526 0.538408 18.3195 0.538408 17.9289 0.928932C17.5384 1.31946 17.5384 1.95262 17.9289 2.34315L23.5858 8L17.9289 13.6569C17.5384 14.0474 17.5384 14.6805 17.9289 15.0711C18.3195 15.4616 18.9526 15.4616 19.3431 15.0711L25.7071 8.70711ZM0 9H25V7H0V9Z" fill="#2B2B2B"/>
            </svg>
          </div>
        </div>
      </div>


      <div class="row" data-inview="fadeInUp" data-delay="200">
        <div class="time">
          <p class="title">12h15</p>
        </div>
        <div class="bloc no-click bleu">
          <div class="top">
            <h3 class="title small">Lunch & Connexion Réseautage</h3>
            <p class="text salle">L'Atelier</p>
          </div>
        </div>
      </div>

      <div class="row" data-inview="fadeInUp" data-delay="200">
        <div class="time">
          <p class="title">13h</p>
        </div>
        <div class="bloc" @click.prevent="openconference('event8')">
          <div class="top">
            <h3 class="title small">Hear, Hear! How to Make the Most of Spotify's Tools to Reach your Customers</h3>
            <p class="text salle">Le Labo</p>
          </div>
          <div class="info">
            <div class="speaker">
              <img src="@/assets/img/spotify.png" alt="Spotify" />
              <p class="text name"><span>/</span>  Spotify</p>
            </div>
          </div>
          <div class="arrow">
            <svg width="26" height="16" viewBox="0 0 26 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M25.7071 8.70711C26.0976 8.31658 26.0976 7.68342 25.7071 7.29289L19.3431 0.928932C18.9526 0.538408 18.3195 0.538408 17.9289 0.928932C17.5384 1.31946 17.5384 1.95262 17.9289 2.34315L23.5858 8L17.9289 13.6569C17.5384 14.0474 17.5384 14.6805 17.9289 15.0711C18.3195 15.4616 18.9526 15.4616 19.3431 15.0711L25.7071 8.70711ZM0 9H25V7H0V9Z" fill="#2B2B2B"/>
            </svg>

          </div>
        </div>
      </div>

      <div class="row" data-inview="fadeInUp" data-delay="200">
        <div class="time">
          <p class="title">13h30</p>
        </div>
        <div class="bloc-wrap">
          <div class="bloc" @click.prevent="openconference('event9')">
            <div class="top">
              <h3 class="title small">Cas Nutella : Comment recadrer le message pour protéger sa marque</h3>
              <p class="text salle">L'Atelier</p>
            </div>
            <div class="info">
              <div class="speaker">
                <img src="@/assets/img/sebastien-voyer.png" alt="Sébastien Voyer" />
                <p class="text name"><span>/</span> Sébastien Voyer</p>
              </div>
            </div>
            <div class="arrow">
              <svg width="26" height="16" viewBox="0 0 26 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M25.7071 8.70711C26.0976 8.31658 26.0976 7.68342 25.7071 7.29289L19.3431 0.928932C18.9526 0.538408 18.3195 0.538408 17.9289 0.928932C17.5384 1.31946 17.5384 1.95262 17.9289 2.34315L23.5858 8L17.9289 13.6569C17.5384 14.0474 17.5384 14.6805 17.9289 15.0711C18.3195 15.4616 18.9526 15.4616 19.3431 15.0711L25.7071 8.70711ZM0 9H25V7H0V9Z" fill="#2B2B2B"/>
              </svg>

            </div>
          </div>
          <p class="text or">ou</p>
          <div class="bloc" @click.prevent="openconference('event10')">
            <div class="top">
              <h3 class="title small">Go Big, Go North: Mastering Canada’s Vast and Diverse Markets</h3>
              <p class="text salle">Le Labo</p>
            </div>
            <div class="info">
              <div class="speaker">
                <img src="@/assets/img/ophelie.png" alt="Ophelie Zalcmanis-Lai" />
                <img src="@/assets/img/river-lariviere.png" alt="River Larivière" class="ml" />
                <p class="text name"><span>/</span> Ophelie Zalcmanis-Lai <br> River Larivière</p>
              </div>
            </div>
            <div class="arrow">
              <svg width="26" height="16" viewBox="0 0 26 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M25.7071 8.70711C26.0976 8.31658 26.0976 7.68342 25.7071 7.29289L19.3431 0.928932C18.9526 0.538408 18.3195 0.538408 17.9289 0.928932C17.5384 1.31946 17.5384 1.95262 17.9289 2.34315L23.5858 8L17.9289 13.6569C17.5384 14.0474 17.5384 14.6805 17.9289 15.0711C18.3195 15.4616 18.9526 15.4616 19.3431 15.0711L25.7071 8.70711ZM0 9H25V7H0V9Z" fill="#2B2B2B"/>
              </svg>

            </div>
          </div>
        </div>
      </div>

      <div class="row" data-inview="fadeInUp" data-delay="200">
        <div class="time">
          <p class="title">14h10</p>
        </div>
        <div class="bloc" @click.prevent="openconference('event11')">
          <div class="top">
            <h3 class="title small">Insight-Out Growth</h3>
            <p class="text salle">Le Labo</p>
          </div>
          <div class="info">
            <div class="speaker">
              <img src="@/assets/img/ron-tite.png" alt="" />
              <p class="text name"><span>/</span> Ron Tite</p>
            </div>
          </div>
          <div class="arrow">
            <svg width="26" height="16" viewBox="0 0 26 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M25.7071 8.70711C26.0976 8.31658 26.0976 7.68342 25.7071 7.29289L19.3431 0.928932C18.9526 0.538408 18.3195 0.538408 17.9289 0.928932C17.5384 1.31946 17.5384 1.95262 17.9289 2.34315L23.5858 8L17.9289 13.6569C17.5384 14.0474 17.5384 14.6805 17.9289 15.0711C18.3195 15.4616 18.9526 15.4616 19.3431 15.0711L25.7071 8.70711ZM0 9H25V7H0V9Z" fill="#2B2B2B"/>
            </svg>

          </div>
        </div>
      </div>

      <div class="row" data-inview="fadeInUp" data-delay="200">
        <div class="time">
          <p class="title">14h50</p>
        </div>
        <div class="bloc no-click">
          <div class="top">
            <h3 class="title small">Mot de la fin et connexion formule réseautage</h3>
            <p class="text salle">Le Labo</p>
          </div>
          <div class="info">
            <div class="speaker">
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="img-bloc yellow">
      <div class="data" data-inview="slideRight" data-delay="200">
        <h2 class="title medium">NE MANQUEZ PAS ÇA !</h2>
        <p class="text darker">
          Le 22 janvier prochain, on vous attend dès 9h30 à la microbrasserie Messorem.
        </p>
        <h3 class="title small">MESSOREM</h3>
        <p class="text darker">2233 Rue Pitt, Montréal, QC H4E 4H2</p>
        <!-- <a href="#" class="cta" @click.prevent="openform"><p class="caps-bold">Confirmer ma présence</p></a> -->
      </div>
      <div class="img" data-inview="slideLeft" data-delay="200">
        <a
          href="https://www.google.com/maps?q=messorem+bracitorium&gs_lcrp=EgZjaHJvbWUqDQgBEC4YrwEYxwEYgAQyBggAEEUYOTINCAEQLhivARjHARiABDIHCAIQABiABDIHCAMQABiABDIHCAQQABiABDIHCAUQABiABDIHCAYQABiABDIHCAcQABiABDIHCAgQABiABNIBCDM2ODJqMGoxqAIAsAIA&um=1&ie=UTF-8"
          target="_blank"
          ><img src="@/assets/img/messorem.svg" alt="Google map"
        /></a>
      </div>
    </section>

    <section class="footer">
      <img class="logo" src="@/assets/img/substance-logo-2023.png" alt="Logo Substance">
    </section>

    <!--FORM-->
    <section class="panel-wrap" :class="{ active: form }">
      <div class="panel" v-if="!isSuccess">
        <svg width="24" height="23" viewBox="0 0 24 23" fill="none" xmlns="http://www.w3.org/2000/svg" @click.prevent="closeform" class="close">
          <path d="M2 2L22 21.0482" stroke="#2B2B2B" stroke-width="3"/>
          <path d="M22 2L2 21.0482" stroke="#2B2B2B" stroke-width="3"/>
        </svg>

        <p class="title small">Confirmer ma présence</p>

        <form action="/?success=1" name="soumissions" method="post" enctype="multipart/form-data" @submit="sendForm">
          <input v-model="formData.nom" type="text" placeholder="Prénom et nom" required />
          <input v-model="formData.entreprise" type="text" placeholder="Entreprise" required />
          <input v-model="formData.courriel" type="mail" placeholder="Courriel" required>

          <div class="wrap">
            <p class="title hour">9h30</p>
            <label class="choice" @click.prevent.stop="addFormation('9h30 : Arrivée, café, muffins')" >
              <div class="prevent"></div>
              Arrivée, café, muffins
              <input type="checkbox" value="Connexion formule réseautage" :checked="formData.formations.includes('9h30 : Arrivée, café, muffins')" />
              <div class="checkbox-faker"></div>
            </label>
          </div>

          <div class="wrap">
            <p class="title hour">10h</p>

            <label class="choice half" @click.prevent.stop="addFormation('10h : L’IA : entre fantasmes et faits', '10h')" >
              <div class="prevent"></div>
              L’IA : entre fantasmes et faits
              <input type="radio" value="L’IA : entre fantasmes et faits" :checked="formData.formations.includes('10h : L’IA : entre fantasmes et faits')" />
              <div class="radio-faker"></div>
            </label>
            <p class="text">ou</p>
            <label class="choice half" @click.prevent.stop="addFormation('10h : Micro, Nano, Macro influenceurs : quelle approche privilégier ?', '10h')" >
              <div class="prevent"></div>
              Micro, Nano, Macro influenceurs : quelle approche privilégier ?
              <input type="radio" value="Micro, Nano, Macro influenceurs : quelle approche privilégier ?" :checked="formData.formations.includes('10h : Micro, Nano, Macro influenceurs : quelle approche privilégier ?')" />
              <div class="radio-faker"></div>
            </label>
          </div>

          <div class="wrap">
            <p class="title hour">10h30</p>

            <label class="choice half" @click.prevent.stop="addFormation('10h30 : L\'influence repensée : de création à amplification', '10h30')" >
              <div class="prevent"></div>
              L'influence repensée : de création à amplification
              <input type="radio" value="L'influence repensée : de création à amplification" :checked="formData.formations.includes('10h30 : L\'influence repensée : de création à amplification')" />
              <div class="radio-faker"></div>
            </label>
            <p class="text">ou</p>
            <label class="choice half" @click.prevent.stop="addFormation('10h30 : De la visibilité à la considération: Brancher les RP au parcours client', '10h30')" >
              <div class="prevent"></div>
              De la visibilité à la considération: Brancher les RP au parcours client
              <input type="radio" value="De la visibilité à la considération: Brancher les RP au parcours client" :checked="formData.formations.includes('10h30 : De la visibilité à la considération: Brancher les RP au parcours client')" />
              <div class="radio-faker"></div>
            </label>
          </div>

          <div class="wrap">
            <p class="title hour">11h</p>

            <label class="choice half" @click.prevent.stop="addFormation('11h : Cas RONA : L\'influence au service de la marque', '11h')" >
              <div class="prevent"></div>
              Cas RONA : L'influence au service de la marque
              <input type="radio" value="Cas RONA : L'influence au service de la marque" :checked="formData.formations.includes('11h : Cas RONA : L\'influence au service de la marque')" />
              <div class="radio-faker"></div>
            </label>
            <p class="text">ou</p>
            <label class="choice half" @click.prevent.stop="addFormation('11h : Nos apprentissages pour la recette du Ecom', '11h')" >
              <div class="prevent"></div>
              Nos apprentissages pour la recette du Ecom
              <input type="radio" value="Nos apprentissages pour la recette du Ecom" :checked="formData.formations.includes('11h : Nos apprentissages pour la recette du Ecom')" />
              <div class="radio-faker"></div>
            </label>
          </div>

          <div class="wrap">
            <p class="title hour">11h30</p>
            <label class="choice half" @click.prevent.stop="addFormation('11h30 : GAFAM vs. médias d\'ici : Se démarquer pour atteindre les objectifs', '11h30')" >
              <div class="prevent"></div>
              GAFAM vs. médias d'ici : Se démarquer pour atteindre les objectifs
              <input type="radio" value="GAFAM vs. médias d'ici : Se démarquer pour atteindre les objectifs" :checked="formData.formations.includes('11h30 : GAFAM vs. médias d\'ici : Se démarquer pour atteindre les objectifs')" />
              <div class="radio-faker"></div>
            </label>
          </div>

          <div class="wrap">
            <p class="title hour">12h15</p>
            <label class="choice" @click.prevent.stop="addFormation('12h15 : Lunch & Connexion Réseautage')" >
              <div class="prevent"></div>
              Lunch & Connexion Réseautage
              <input type="checkbox" value="Lunch & Connexion Réseautage" :checked="formData.formations.includes('12h15 : Lunch & Connexion Réseautage')" />
              <div class="checkbox-faker"></div>
            </label>
          </div>

          <div class="wrap">
            <p class="title hour">13h</p>
            <label class="choice" @click.prevent.stop="addFormation('13h : Hear, Hear! How to Make the Most of Spotify\'s Tools to Reach your Customers')" >
              <div class="prevent"></div>
              Hear, Hear! How to Make the Most of Spotify's Tools to Reach your Customers
              <input type="checkbox" value="Hear, Hear! How to Make the Most of Spotify's Tools to Reach your Customers" :checked="formData.formations.includes('13h : Hear, Hear! How to Make the Most of Spotify\'s Tools to Reach your Customers')" />
              <div class="checkbox-faker"></div>
            </label>
          </div>

          <!-- <div class="wrap">
            <p class="title hour">13h15</p>
            <label class="choice" @click.prevent.stop="addFormation('13h15 : Cas Nutella : Comment recadrer le message pour protéger sa marque')" >
              <div class="prevent"></div>
              Cas Nutella : Comment recadrer le message pour protéger sa marque
              <input type="checkbox" value="Cas Nutella : Comment recadrer le message pour protéger sa marque" :checked="formData.formations.includes('13h15 : Cas Nutella : Comment recadrer le message pour protéger sa marque')" />
              <div class="checkbox-faker"></div>
            </label>
          </div>

          <div class="wrap">
            <p class="title hour">13h30</p>
            <label class="choice" @click.prevent.stop="addFormation('13h30 : Go Big, Go North: Mastering Canada’s Vast and Diverse Markets')" >
              <div class="prevent"></div>
              Go Big, Go North: Mastering Canada’s Vast and Diverse Markets
              <input type="checkbox" value="Go Big, Go North: Mastering Canada’s Vast and Diverse Markets" :checked="formData.formations.includes('13h30 : Go Big, Go North: Mastering Canada’s Vast and Diverse Markets')" />
              <div class="checkbox-faker"></div>
            </label>
          </div> -->

          <div class="wrap">
            <p class="title hour">13h30</p>

            <label class="choice" @click.prevent.stop="addFormation('13h30 : Cas Nutella : Comment recadrer le message pour protéger sa marque', '13h30')" >
              <div class="prevent"></div>
              Cas Nutella : Comment recadrer le message pour protéger sa marque
              <input type="checkbox" value="Cas Nutella : Comment recadrer le message pour protéger sa marque" :checked="formData.formations.includes('13h30 : Cas Nutella : Comment recadrer le message pour protéger sa marque')" />
              <div class="checkbox-faker"></div>
            </label>
            <p class="text">ou</p>
            <label class="choice" @click.prevent.stop="addFormation('13h30 : Go Big, Go North: Mastering Canada’s Vast and Diverse Markets', '13h30')" >
              <div class="prevent"></div>
              Go Big, Go North: Mastering Canada’s Vast and Diverse Markets
              <input type="checkbox" value="Go Big, Go North: Mastering Canada’s Vast and Diverse Markets" :checked="formData.formations.includes('13h30 : Go Big, Go North: Mastering Canada’s Vast and Diverse Markets')" />
              <div class="checkbox-faker"></div>
            </label>
          </div>

          <div class="wrap">
            <p class="title hour">14h10</p>
            <label class="choice" @click.prevent.stop="addFormation('14h10 : Insight-Out Growth')" >
              <div class="prevent"></div>
              Insight-Out Growth
              <input type="checkbox" value="Insight-Out Growth" :checked="formData.formations.includes('14h10 : Insight-Out Growth')" />
              <div class="checkbox-faker"></div>
            </label>
          </div>

          <input type="submit" value="Envoyer ma participation">
        </form>

      </div>
      <div class="panel success-screen" v-else>
        <svg width="24" height="23" viewBox="0 0 24 23" fill="none" xmlns="http://www.w3.org/2000/svg" @click.prevent="closeform" class="close">
          <path d="M2 2L22 21.0482" stroke="#2B2B2B" stroke-width="3"/>
          <path d="M22 2L2 21.0482" stroke="#2B2B2B" stroke-width="3"/>
        </svg>
        
        <p class="title small">Merci de votre <br> inscription!</p>
        <p class="text">
        <br>
        Rendez-vous le 22 janvier prochain à la brasserie Messorem </p>
      </div>
      <div class="overlay" @click.prevent="closeform"></div>
    </section>

    <!--Conférence Panel-->
    <section class="panel-wrap" :class="{ active: conference }">
      <div class="panel">
        <svg width="24" height="23" viewBox="0 0 24 23" fill="none" xmlns="http://www.w3.org/2000/svg" @click.prevent="closeconference" class="close">
          <path d="M2 2L22 21.0482" stroke="#2B2B2B" stroke-width="3"/>
          <path d="M22 2L2 21.0482" stroke="#2B2B2B" stroke-width="3"/>
        </svg>

        <div class="event" :class="{ show: show === 'event1' }">
          <div class="top">
            <p class="hour title">10h</p>
            <h3 class="title small">L’IA : entre fantasmes et faits</h3>
           <p class="text salle">Le Labo</p>
          </div>
          <div class="description">
              <p class="text">Impossible de discuter de l'industrie du marketing sans parler intelligence artificielle. Apprenez comment naviguer cette technologie en constante évolution et comment l'intégrer dans vos opérations quotidiennes de manière stratégique, éthique et responsable.</p>
          </div>
          <div class="speaker">
            <img src="@/assets/img/river-lariviere.png" alt="River Larivière" />
            <p class="text name"><span>/</span>  River Larivière</p>
          </div>
          <div class="speaker">
            <img src="@/assets/img/marie-jade.webp" alt="Marie-Jade Filion" />
            <p class="text name"><span>/</span>  Marie-Jade Filion</p>
          </div>
          <div class="speaker">
            <img src="@/assets/img/genevieve-harel.png" alt="Geneviève Harel" />
            <p class="text name"><span>/</span> Geneviève Harel</p>
          </div>
          <a href="#" class="cta" @click.prevent="function() { openform(); closeconference(); }"><p class="caps-bold">Confirmer ma présence</p></a>
        </div>

        <div class="event" :class="{ show: show === 'event2' }">
          <div class="top">
            <p class="hour title">10h</p>
            <h3 class="title small">Micro, Nano, Macro influenceurs : quelle approche privilégier ?</h3>
            <p class="text salle">L'Atelier</p>
          </div>
          <div class="description">
            <p class="text">On sait toustes que l'influence joue un rôle crucial dans la stratégie, mais c'est une industrie qui change rapidement. Comment activer le bon mix de nano, micro, macro et mega-influenceurs selon le contexte?</p>
          </div>

          <div class="speaker">
            <img src="@/assets/img/marc-andre.webp" alt="Marc-André Dufresne" />
            <p class="text name"><span>/</span> Marc-André Dufresne</p>
          </div>

          <div class="speaker">
            <img src="@/assets/img/martin-alexis.png" alt="Martin Alexis Ramirez" />
            <p class="text name"><span>/</span> Martin Alexis Ramirez</p>
          </div>

          <a href="#" class="cta" @click.prevent="function() { openform(); closeconference(); }"><p class="caps-bold">Confirmer ma présence</p></a>
        </div>

        <div class="event" :class="{ show: show === 'event3' }">
          <div class="top">
            <p class="hour title">10h30</p>
            <h3 class="title small">L'influence repensée : de création à amplification</h3>
           <p class="text salle">Le Labo</p>
          </div>
          <div class="description">
            <p class="text">L'influence, c'est un levier stratégique activable sur l'ensemble du funnel. De l’idéation à la production, jusqu’à l’amplification payante, les marques ont désormais l’opportunité de maximiser la performance de leurs contenus influenceurs.</p>
          </div>
          <div class="speaker">
            <img src="@/assets/img/marc-andre.webp" alt="Marc-André Dufresne">
            <p class="text name"><span>/</span> Marc-André Dufresne</p>
          </div>
          <div class="speaker">
            <img src="@/assets/img/elise.webp" alt="Élise El-Nawar ">
            <p class="text name"><span>/</span> Élise El-Nawar</p>
          </div>
          <a href="#" class="cta" @click.prevent="function() { openform(); closeconference(); }"><p class="caps-bold">Confirmer ma présence</p></a>
        </div>

        <div class="event" :class="{ show: show === 'event4' }">
          <div class="top">
            <p class="hour title">10h30</p>
            <h3 class="title small">De la visibilité à la considération: Brancher les RP au parcours client</h3>
           <p class="text salle">L'Atelier</p>
          </div>
          <div class="description">
            <p class="text">Les relations publiques, c'est bien plus qu'un bonus de notoriété. C'est un outil de crédibilité essentiel à tout funnel complet, particulièrement en considération. Découvrez comment tirer le meilleur profit de cette tactique et ce, à chaque étape du parcours client.</p>
          </div>
          <div class="speaker">
            <img src="@/assets/img/sebastien-voyer.png" alt="Sébastien Voyer" />
            <p class="text name"><span>/</span> Sébastien Voyer</p>
          </div>
          <div class="speaker">
            <img src="@/assets/img/juliette-ferland.png" alt="Juliette Ferland" />
            <p class="text name"><span>/</span> Juliette Ferland</p>
          </div>
          <a href="#" class="cta" @click.prevent="function() { openform(); closeconference(); }"><p class="caps-bold">Confirmer ma présence</p></a>
        </div>

        <div class="event" :class="{ show: show === 'event5' }">
          <div class="top">
            <p class="hour title">11h</p>
            <h3 class="title small">Cas RONA : L'influence au service de la marque</h3>
            <p class="text salle">Le Labo</p>
          </div>
          <div class="description">
            <p class="text">Dans la dernière année, l'influence a été un véritable moteur de performance. Découvrez la recette qui a renforcé le leadership de RONA dans la rénovation au Canada : une approche d’influence crédible et inspirante qui a solidifié la confiance des communautés envers la marque.</p>
          </div>

          <div class="speaker">
            <img src="@/assets/img/vanessa-beauregard.png" alt="Vanessa Beauregard" />
            <p class="text name"><span>/</span> Vanessa Beauregard</p>
          </div>
          <div class="speaker">
            <img src="@/assets/img/caroline-hurtubise.png" alt="Caroline Hurtubise"/>
            <p class="text name"><span>/</span> Caroline Hurtubise</p>
          </div>

          <a href="#" class="cta" @click.prevent="function() { openform(); closeconference(); }"><p class="caps-bold">Confirmer ma présence</p></a>
        </div>

        <div class="event" :class="{ show: show === 'event6' }">
          <div class="top">
            <p class="hour title">11h</p>
            <h3 class="title small">Nos apprentissages pour la recette du Ecom</h3>
           <p class="text salle">L'Atelier</p>
          </div>
          <div class="description">
            <p class="text">Voici le plan de match essentiel pour des campagnes e-commerce qui transforment les clics en bénéfices. Décortiquons les cinq piliers cruciaux d'une planification média numérique réussie. Si vous cherchez les ingrédients secrets pour maximiser vos rendements, cette session est pour vous.</p>
          </div>
          <div class="speaker">
            <img src="@/assets/img/philippe.png" alt="Philippe Petrin">
            <p class="text name"><span>/</span> Philippe Petrin</p>
          </div>
          <a href="#" class="cta" @click.prevent="function() { openform(); closeconference(); }"><p class="caps-bold">Confirmer ma présence</p></a>
        </div>

        <div class="event" :class="{ show: show === 'event7' }">
          <div class="top">
            <p class="hour title">11h30</p>
            <h3 class="title small">GAFAM vs. médias d'ici : Se démarquer pour atteindre les objectifs</h3>
            <p class="text salle">Le Labo</p>
          </div>
          <div class="description">
            <p class="text">Les médias d'ici tiennent tête aux géants mondiaux comme pôle essentiel dans notre écosystème. Comment mettre à profit de nouvelles technologies et stratégies pour maintenir cette performance et consolider sa place dans le milieu? Assistez à notre panel d'experts.</p>
          </div>
          <div class="speaker">
            <img src="@/assets/img/guillaume-brunet.png" alt="Guillaume Brunet" />
            <p class="text name"><span>/</span> Guillaume Brunet</p>
          </div>

          <div class="speaker">
            <img src="@/assets/img/lapresse.png" alt="La Presse" />
            <p class="text name"><span>/</span> La Presse</p>
          </div>

          <div class="speaker">
            <img src="@/assets/img/globe-mail.png" alt="Globe and Mail" />
            <p class="text name"><span>/</span> Globe and Mail</p>
          </div>

          <div class="speaker">
            <img src="@/assets/img/cegeco.png" alt="Média Tonik" />
            <p class="text name"><span>/</span> Cogeco</p>
          </div>

          <div class="speaker">
            <img src="@/assets/img/pelmorex.png" alt="Pelmorex" />
            <p class="text name"><span>/</span> Pelmorex</p>
          </div>


          <a href="#" class="cta" @click.prevent="function() { openform(); closeconference(); }"><p class="caps-bold">Confirmer ma présence</p></a>
        </div>

        <div class="event" :class="{ show: show === 'event8' }">
          <div class="top">
            <p class="hour title">13h</p>
            <h3 class="title small">Hear, Hear! How to Make the Most of Spotify's Tools to Reach your Customers</h3>
           <p class="text salle">Le Labo</p>
          </div>
          <div class="description">
            <p class="text">Spotify is the #1 audio streaming platform in Canada, but that's not the only reason it's a powerful tool for reaching your audience. In this conference, Spotify experts break down how to leverage extensive customer data and insights, optimize personalization and targeting tools, and use their new innovative formats to empower your brand to connect with relevant listeners.</p>
          </div>
          <div class="speaker">
            <img src="@/assets/img/spotify.png" alt="Spotify" />
            <p class="text name"><span>/</span>  Spotify</p>
          </div>
          <a href="#" class="cta" @click.prevent="function() { openform(); closeconference(); }"><p class="caps-bold">Confirmer ma présence</p></a>
        </div>

        <div class="event" :class="{ show: show === 'event9' }">
          <div class="top">
            <p class="hour title">13h30</p>
            <h3 class="title small">Étude de cas Nutella | Démêler le vrai du faux: quand les mythes façonnent la réputation des marques</h3>
            <p class="text salle">L'Atelier</p>
          </div>
          <div class="description">
            <p class="text">La désinformation est à son apogée et elle se propage plus rapidement que jamais. Mais qu'est-ce qui arrive lorsqu'une fabrication affecte la réputation de votre marque? Étudiez le cas Nutella et le mythe de l'huile de palme pour découvrir comment remettre les pendules à l'heure et rétablir la confiance.</p>
          </div>
          <div class="speaker">
            <img src="@/assets/img/sebastien-voyer.png" alt="Sébastien Voyer" />
            <p class="text name"><span>/</span> Sébastien Voyer</p>
          </div>
          <a href="#" class="cta" @click.prevent="function() { openform(); closeconference(); }"><p class="caps-bold">Confirmer ma présence</p></a>
        </div>

        <div class="event" :class="{ show: show === 'event10' }">
          <div class="top">
            <p class="hour title">13h30</p>
            <h3 class="title small">Go Big, Go North: Mastering Canada’s Vast and Diverse Markets</h3>
           <p class="text salle">Le Labo</p>
          </div>
          <div class="description">

              <p class="text">2025 was the year of Canada-first marketing. But is it here to stay? Here's our lookback on a year marked by this local approach, as well as our thoughts on how to leverage our identities with authenticity moving forward.</p>

          </div>
          <div class="speaker">
            <img src="@/assets/img/ophelie.png" alt="Ophelie Zalcmanis-Lai" />
            <p class="text name"><span>/</span> Ophelie Zalcmanis-Lai</p>
          </div>
          <div class="speaker">
            <img src="@/assets/img/river-lariviere.png" alt="River Larivière" />
            <p class="text name"><span>/</span> River Larivière</p>
          </div>
          <a href="#" class="cta" @click.prevent="function() { openform(); closeconference(); }"><p class="caps-bold">Confirmer ma présence</p></a>
        </div>

        <div class="event" :class="{ show: show === 'event11' }">
          <div class="top">
            <p class="hour title">14h10</p>
            <h3 class="title small">Insight-Out Growth</h3>
           <p class="text salle">Le Labo</p>
          </div>
          <div class="description">

              <p class="text">Learn how to turn raw data into meaningful customer realities to drive campaigns that truly resonate with your audience. The key? Start with insight, move with purpose, and let customer truth compound into momentum.</p>

          </div>
          <div class="speaker">
              <img src="@/assets/img/ron-tite.png" alt="" />
              <p class="text name"><span>/</span> Ron Tite</p>
            </div>
          <a href="#" class="cta" @click.prevent="function() { openform(); closeconference(); }"><p class="caps-bold">Confirmer ma présence</p></a>
        </div>

      </div>
      <div class="overlay" @click.prevent="closeconference"></div>
    </section>

  </div>
</template>

<script>
import { mapState } from 'vuex'


import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

import createContact from '@/misc/firebase-init'

gsap.registerPlugin(ScrollTrigger)

// Intro Animation Scripts
require('@/misc/animations-layer')

export default {
  head() {
    return {
      title: {
        inner: 'Le LAB SUBSTANCE - Votre rendez-vous périodique',
        separator: ' ',
        complement: '',
      },
      meta: [
        {
          name: 'description',
          content: 'Après le succès des formations pour notre 10e anniversaire de l\'année dernière, on vous invite au Lab Substance. À travers plusieurs ateliers avec nos spécialistes, apprenez les meilleures pratiques du marketing en 2024, les tendances en ébullition, en plus de nos prédictions sur l\'industrie en 2025.',
          id: 'desc'
        },
        { name: 'application-name', content: 'Le LAB SUBSTANCE - Votre rendez-vous périodique' },
        { name: 'twitter:title', content: 'Après le succès des formations pour notre 10e anniversaire de l\'année dernière, on vous invite au Lab Substance. À travers plusieurs ateliers avec nos spécialistes, apprenez les meilleures pratiques du marketing en 2024, les tendances en ébullition, en plus de nos prédictions sur l\'industrie en 2025.'},
        { name: 'twitter:card', content: 'summary' },
        {
          n: 'twitter:description',
          c: 'Après le succès des formations pour notre 10e anniversaire de l\'année dernière, on vous invite au Lab Substance. À travers plusieurs ateliers avec nos spécialistes, apprenez les meilleures pratiques du marketing en 2024, les tendances en ébullition, en plus de nos prédictions sur l\'industrie en 2025.'
        },
        // Facebook / Open Graph
        { property: 'og:title', content: 'Le LAB SUBSTANCE - Votre rendez-vous périodique' },
        { property: 'og:site_name', content: 'Le LAB SUBSTANCE - Votre rendez-vous périodique' },
        {
          property: 'og:description',
          content: 'Après le succès des formations pour notre 10e anniversaire de l\'année dernière, on vous invite au Lab Substance. À travers plusieurs ateliers avec nos spécialistes, apprenez les meilleures pratiques du marketing en 2024, les tendances en ébullition, en plus de nos prédictions sur l\'industrie en 2025.'
        },
        // Og Image
        {
          p: 'og:image',
          c: 'https://substance-10-ans.netlify.app/img/og.jpg'
        },
        {
          name: 'twitter:image',
          content: 'https://substance-10-ans.netlify.app/img/og.jpg'
        }
      ]
    }
  },

  mounted() {
    this.initGsapUtils()
  },

  watch: {
    $route: {
      handler($route) {
        if ($route && $route.query.success === '1') {
          this.openform()
          this.isSuccess = true
        }
      },
      immediate: true,
    },
  },

  data() {
    return {
      form: false,
      conference: false,
      show: null,
      isSuccess: false,
      formData: {
        nom: '',
        entreprise: '',
        courriel: '',
        formations: []
      },
      isSending: false
    }
  },

  methods: {

    initGsapUtils() {
      const mtl = document.querySelector('.anim-mtl')
      const date = document.querySelector('.anim-date')
      const hour = document.querySelector('.anim-hour')

      if (mtl && date && hour) {

        gsap.to(mtl, {
          scrollTrigger: {
            trigger: mtl,
            start: 'top bottom',
            end: 'bottom top',
            scrub: 2
          },
          rotation: 180,
          ease: 'none'
        })

        gsap.to(date, {
          scrollTrigger: {
            trigger: date,
            start: 'top bottom',
            end: 'bottom top',
            scrub: 2
          },
          x: '-50%',
          ease: 'none'
        })

        gsap.to(hour, {
          scrollTrigger: {
            trigger: hour,
            start: 'top bottom',
            end: 'bottom top',
            scrub: 2
          },
          x: '50%',
          ease: 'none'
        })
      }
    },
    
    openconference(uid) {
      this.conference = true
      this.show = uid
    },
    closeconference() {
      this.conference = false
      this.show = null
    },
    openform() {
      this.form = true
    },
    closeform() {
      this.form = false
    },
    addFormation(formation, uniqueTo = false) {
      if (uniqueTo) {
        this.formData.formations = this.formData.formations.filter(item => !item.includes(uniqueTo))
        this.formData.formations.push(formation)
        return
      }

      if (this.formData.formations.includes(formation)) {
        this.formData.formations = this.formData.formations.filter(item => item !== formation)
      } else {
        this.formData.formations.push(formation)
      }
    },
    async sendForm(event) {
      event.preventDefault()

      if (this.isSending) {
        return
      }

      this.isSending = true
      const contact = this.formData

      try {
        await createContact(contact)
        this.formData = {
          nom: '',
          entreprise: '',
          courriel: '',
          formations: []
        }
        window.location.href = '/?success=1'
      } catch (e) {
        this.error = e
        this.isSending = false
      }
    }
  },

  computed: mapState('app', ['appTitle'])
}
</script>

<style lang="scss" scoped>
@import '@/theme/variables.scss';
</style>
